import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import 'leaflet/dist/leaflet.css';
import App from './App/App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
// import { AuthContextProvider } from './contexts/authContext';
import './i18n';
import { isChunkError, reloadWithCacheClear } from './utils/chunkErrorHandler';

const children = (
	<Provider store={store}>
		<ThemeContextProvider>
			<Router>
				{/* <React.StrictMode> */}
				<App />
				{/* </React.StrictMode> */}
			</Router>
		</ThemeContextProvider>
	</Provider>
);

// Global error handler for chunk loading errors
window.addEventListener('error', (event) => {
	if (isChunkError(event.error || { message: event.message })) {
		console.warn('Chunk loading error detected, clearing cache and reloading...');
		event.preventDefault();
		reloadWithCacheClear();
	}
});

window.addEventListener('unhandledrejection', (event) => {
	if (isChunkError(event.reason)) {
		console.warn('Chunk loading promise rejection detected, clearing cache and reloading...');
		event.preventDefault();
		reloadWithCacheClear();
	}
});

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
